export class SrEventListModel {
  static readonly serviceName = 'features/event/sr-event/list'
}

export interface SrEventListItem {
  id: number
  typeOfContact: string
  title: string
  description: string
  journalEntry?: string
  plannedFrom: string
  plannedTo?: string // Optional, as it might not always be present
  realizedFrom?: string | null
  realizedTo?: string | null
  rrule?: string | null
  workType?: string | null
  clients: Client[]
  workers: Worker[]
}

export interface Client {
  id: number
  firstName: string
  lastName: string
}

export interface Worker {
  id: number
  firstName: string
  lastName: string
}

export interface SrEventListResponse {
  data: SrEventListItem[]
  total: number
  limit: number
  skip: number
}
